<!-- 合并帐操作 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn" style="font-size: 18px; font-weight: 700; margin: 5px">合并前：</div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" max-height="450px" v-loading="loading" :data="tableData" border="" ref="multipleTable" style="width: 100%; margin-bottom: 10px">
                <el-table-column show-overflow-tooltip width="52" type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip width="185" prop="OrderCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="OrderType" label="单据类型">
                    <template slot-scope="scope">
                        <i v-if="scope.row.OrderType == 0" class="c-active">销售收款</i>
                        <i v-else-if="scope.row.OrderType == 1" class="out-active">销售退货</i>
                        <i v-else-if="scope.row.PRType == 11">合并账</i>
                        <i v-else>建账</i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="TotalAmount" label="应收总额">
                    <template slot-scope="scope">{{ scope.row.OrderType == 1 ? -scope.row.TotalAmount : scope.row.TotalAmount }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="AgentAmount" label="代收总额">
                    <template slot-scope="scope">{{ scope.row.IsAgent ? scope.row.AgentAmount : 0 }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="TotalAmount" label="实收总额">
                    <template slot-scope="scope">{{
                        scope.row.OrderType == 1 ? -scope.row.TotalAmount : scope.row.IsAgent ? (scope.row.TotalAmount - scope.row.AgentAmount).toFixed(2) : scope.row.TotalAmount
                    }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="90" prop="Remark" label="备注"></el-table-column>
            </el-table>
        </div>
        <div class="search-ctn" style="font-size: 18px; font-weight: 700; margin: 5px">合并后：</div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="afterTableData"
                border=""
                ref="multipleTable"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column show-overflow-tooltip width="52" type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip width="185" prop="OrderCode" label="单号">
                    <template>
                        <i v-if="hbCode" style="color: red">{{ hbCode }}</i>
                        <i v-else style="color: #d3d3d3">提加后将自动生成</i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="OrderType" label="单据类型">
                    <template>
                        <i>合并帐</i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="TAmount" label="应收总额">
                    <template slot-scope="scope">{{ scope.row.TAmount.toFixed(2) }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="AgentAmount" label="代收总额">
                    <template slot-scope="scope">{{ scope.row.IsAgent ? scope.row.AgentAmount.toFixed(2) : 0 }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" label="实收总额">
                    <template slot-scope="scope">{{ scope.row.IsAgent ? (scope.row.TAmount - scope.row.AgentAmount).toFixed(2) : scope.row.TAmount.toFixed(2) }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="90" prop="Remark" label="备注">
                    <!-- input 要加 scope才能输入，别删 -->
                    <template slot-scope="scope">
                        <el-input v-model="submitData.Remark"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-footer">
            <div class="re-submit">
                <el-button class="btn-primary" size="small" @click="submitForm()">提交</el-button>
                <el-button @click="cancel()" size="small">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['CombineList'],
    components: {},
    data() {
        return {
            loading: false,
            submitData: {
                RecordIds: [],
                Remark: '',
                OrderCodes:''
            },
            tableData: [],
            afterTableData: [],
            hbCode: ''
        };
    },
    mounted() {
        if (this.CombineList && this.CombineList.length > 1) {
            this.tableData = this.CombineList;

            let hbs = this.CombineList.filter(f => f.PRType == 11);
            if (hbs && hbs.length == 1) {
                this.hbCode = hbs[0].OrderCode;
            }

            let os = this.CombineList.filter(f => f.IsAgent);
            let isAgent = os && os.length > 0;
            let data = {
                TAmount: 0,
                AgentAmount: 0,
                IsAgent: isAgent
            };
            let remark = '';
            this.submitData.OrderCodes='';
            for (let i = 0; i < this.CombineList.length; i++) {
                this.submitData.RecordIds.push(this.CombineList[i].RecordId);
                if (this.CombineList[i].OrderType == 1) {
                    data.TAmount -= Number(this.CombineList[i].TotalAmount);
                } else {
                    data.TAmount += Number(this.CombineList[i].TotalAmount);
                    if (this.CombineList[i].OrderType == 0 && this.CombineList[i].IsAgent) data.AgentAmount += Number(this.CombineList[i].AgentAmount);
                }
                if (this.CombineList[i].PRType == 11) remark += this.CombineList[i].Remark;
                this.submitData.OrderCodes+=','+this.CombineList[i].OrderCode;
            }
            this.submitData.Remark = remark;
            this.afterTableData.push(data);
        } else this.$util.warningMsg('合并项需要具备两条或两条以上数据');
    },
    methods: {
        submitForm() {
            let that = this;
            if (that.loading) return false;
            if (that.submitData.RecordIds.length <= 1) {
                that.$util.warningMsg('必须具备两条或两条以上数据进行合并');
                return;
            }
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/RevenueManagement_H/CombineAccountDatas',
                    data: that.submitData,
                    hideLoading: true
                })
                .then(res => {
                    that.$util.successMsg(res.errmsg);
                    if (res.errcode === 0) {
                        that.$emit('closeDialog', true);
                    }
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scoped>
.re-submit {
    text-align: right;
}
</style>
